import { Table } from "@mantine/core";

import NewbornTableRows from "@/encounters/components/EncounterLabor/EncounterLaborPostpartum/NewbornPostpartum/NewbornTableRows";
import { usePostpartumObservations } from "@/encounters/components/EncounterLabor/hooks/usePostpartumObservations";
import FlowsheetTable from "@/encounters/components/FlowsheetTable/FlowsheetTable";

export default function NewbornPostpartumFlowsheetTable({
  encounterId,
  clientId,
  showNumbersOnly,
  isViewOnly,
}: {
  encounterId: string;
  clientId: string;
  showNumbersOnly: boolean;
  isViewOnly: boolean;
}) {
  // Use the postpartum observations hook and get birthDateTime and refresh function
  const { birthDateTime, refreshObservations } = usePostpartumObservations(encounterId, clientId);

  return (
    <FlowsheetTable>
      <TableHeader />
      <Table.Tbody>
        <NewbornTableRows
          key={birthDateTime} // Add key to force re-render when birthDateTime changes
          isViewOnly={isViewOnly}
          onRefresh={refreshObservations}
          showNumbersOnly={showNumbersOnly}
        />
      </Table.Tbody>
    </FlowsheetTable>
  );
}

function TableHeader() {
  return (
    <Table.Thead>
      <Table.Tr styles={{ tr: { borderWidth: "2px" } }}>
        <Table.Th ta="center">Time</Table.Th>
        <Table.Th ta="center">HR</Table.Th>
        <Table.Th ta="center">RR</Table.Th>
        <Table.Th ta="center">Temp</Table.Th>
        <Table.Th ta="center">Color</Table.Th>
        <Table.Th ta="center">Void</Table.Th>
        <Table.Th ta="center">Stool</Table.Th>
      </Table.Tr>
    </Table.Thead>
  );
}
